function fieldAddError(field, errMessage) {
  if (!field) return;
  field.classList.add('error');
  let _errMessage = field.querySelector('.error-message');
  if (_errMessage) {
    _errMessage.innerText = errMessage;
  } else {
    let _label = field.querySelector('.form-label');
    if (_label) field.style.setProperty('--label-width', `${_label.clientWidth}px`);
    field.insertAdjacentHTML(
      'beforeend',
      `<span class='error-message invalid-feedback'>${errMessage}</span>`,
    );
  }
}

function fieldRemoveError(field) {
  if (!field) return;
  field.querySelectorAll('.error-message').forEach(el => el.remove());
  field.classList.remove('error');
  field.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
}

function fieldFocus(field) {
  if (!field) return;
  console.log({ field });
  field.scrollIntoView();
  let input = field.querySelector('input');
  if (input) input.focus();
}

function closestFormItem(el) {
  let i = 0;
  while (!el.classList.contains('form-item') && i < 3) {
    if (el.tagName === 'BODY') break;
    el = el.parentNode;
    i++;
  }

  return el.classList.contains('form-item') ? el : null;
}

function validateForm(form) {
  $(form).trigger('validate', new FormData(form));
  let inValidityFields = form.querySelectorAll(':invalid');
  // fieldRemoveError(form);
  let validityFields = form.querySelectorAll(':valid:not([type="submit"]):not(.btn)');
  for (const field of validityFields) {
    let formItem = closestFormItem(field.parentNode);
    fieldRemoveError(formItem);
  }
  for (const field of inValidityFields) {
    let formItem = closestFormItem(field.parentNode);
    fieldAddError(formItem, field.validationMessage);
  }
  if (inValidityFields.length > 0) inValidityFields[0].focus();
}

function replaceInvalidityUi(form) {
  form.addEventListener('invalid', ev => ev.preventDefault(), true);
  form.addEventListener('submit', ev => {
    if (!form.checkValidity) ev.preventDefault();
  });
  form.querySelectorAll('[type=submit], .js-submit').forEach(submitBtn => {
    submitBtn.addEventListener('click', () => validateForm(form));
  });
}

export { replaceInvalidityUi, fieldAddError, fieldRemoveError, fieldFocus, closestFormItem };
